/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AdminRouteImport } from './routes/admin';
import { Route as AdminAppRouteImport } from './routes/admin._app';
import { Route as AdminChangePasswordRouteImport } from './routes/admin.change-password';
import { Route as AdminForgotPasswordRouteImport } from './routes/admin.forgot-password';
import { Route as AdminSignInRouteImport } from './routes/admin.sign-in';
import { Route as AdminVerifyEmailRouteImport } from './routes/admin.verify-email';
import { Route as AdminAppAdvertisementRouteImport } from './routes/admin._app.advertisement';
import { Route as AdminAppBannersRouteImport } from './routes/admin._app.banners';
import { Route as AdminAppDashboardRouteImport } from './routes/admin._app.dashboard';
import { Route as AdminAppInvoicesRouteImport } from './routes/admin._app.invoices';
import { Route as AdminAppNotificationsRouteImport } from './routes/admin._app.notifications';
import { Route as AdminAppPipeRatePredictionsRouteImport } from './routes/admin._app.pipe-rate-predictions';
import { Route as AdminAppPlatformSettingsRouteImport } from './routes/admin._app.platform-settings';
import { Route as AdminAppProfileRouteImport } from './routes/admin._app.profile';
import { Route as AdminAppProjectsRouteImport } from './routes/admin._app.projects';
import { Route as AdminAppPrototypeControlsRouteImport } from './routes/admin._app.prototype-controls';
import { Route as AdminAppTutorialsRouteImport } from './routes/admin._app.tutorials';
import { Route as AdminResetPasswordTokenRouteImport } from './routes/admin.reset-password.$token';
import { Route as AdminVerifyEmailTokenRouteImport } from './routes/admin.verify-email.$token';
import { Route as AdminAppNotificationsIndexRouteImport } from './routes/admin._app.notifications.index';
import { Route as AdminAppNotificationsNewRouteImport } from './routes/admin._app.notifications.new';
import { Route as AdminAppPipeRatePredictionsIndexRouteImport } from './routes/admin._app.pipe-rate-predictions.index';
import { Route as AdminAppPipeRatePredictionsPipeTypeRouteImport } from './routes/admin._app.pipe-rate-predictions.$pipeType';
import { Route as AdminAppPlatformSettingsIndexRouteImport } from './routes/admin._app.platform-settings.index';
import { Route as AdminAppPlatformSettingsCalculationRouteImport } from './routes/admin._app.platform-settings.calculation';
import { Route as AdminAppPlatformSettingsPrivacyPolicyRouteImport } from './routes/admin._app.platform-settings.privacy-policy';
import { Route as AdminAppPlatformSettingsReportPricingRouteImport } from './routes/admin._app.platform-settings.report-pricing';
import { Route as AdminAppPlatformSettingsReportProTipsRouteImport } from './routes/admin._app.platform-settings.report-pro-tips';
import { Route as AdminAppPlatformSettingsTermsConditionsRouteImport } from './routes/admin._app.platform-settings.terms-conditions';
import { Route as AdminAppProjectsIndexRouteImport } from './routes/admin._app.projects.index';
import { Route as AdminAppProjectsProjectIdRouteImport } from './routes/admin._app.projects.$projectId';
import { Route as AdminAppUsersIndexRouteImport } from './routes/admin._app.users.index';
import { Route as AdminAppUsersNewRouteImport } from './routes/admin._app.users.new';
import { Route as AdminAppNotificationsNotificationIdIndexRouteImport } from './routes/admin._app.notifications.$notificationId.index';
import { Route as AdminAppNotificationsNotificationIdEditRouteImport } from './routes/admin._app.notifications.$notificationId.edit';
import { Route as AdminAppUsersUserIdIndexRouteImport } from './routes/admin._app.users.$userId.index';
import { Route as AdminAppUsersUserIdEditRouteImport } from './routes/admin._app.users.$userId.edit';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminAppRoute = AdminAppRouteImport.update({
  id: '/_app',
  getParentRoute: () => AdminRoute,
} as any);
const AdminChangePasswordRoute = AdminChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AdminRoute,
} as any);
const AdminForgotPasswordRoute = AdminForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AdminRoute,
} as any);
const AdminSignInRoute = AdminSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AdminRoute,
} as any);
const AdminVerifyEmailRoute = AdminVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AdminRoute,
} as any);
const AdminAppAdvertisementRoute = AdminAppAdvertisementRouteImport.update({
  id: '/advertisement',
  path: '/advertisement',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppBannersRoute = AdminAppBannersRouteImport.update({
  id: '/banners',
  path: '/banners',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppDashboardRoute = AdminAppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppInvoicesRoute = AdminAppInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppNotificationsRoute = AdminAppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppPipeRatePredictionsRoute =
  AdminAppPipeRatePredictionsRouteImport.update({
    id: '/pipe-rate-predictions',
    path: '/pipe-rate-predictions',
    getParentRoute: () => AdminAppRoute,
  } as any);
const AdminAppPlatformSettingsRoute =
  AdminAppPlatformSettingsRouteImport.update({
    id: '/platform-settings',
    path: '/platform-settings',
    getParentRoute: () => AdminAppRoute,
  } as any);
const AdminAppProfileRoute = AdminAppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppProjectsRoute = AdminAppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppPrototypeControlsRoute =
  AdminAppPrototypeControlsRouteImport.update({
    id: '/prototype-controls',
    path: '/prototype-controls',
    getParentRoute: () => AdminAppRoute,
  } as any);
const AdminAppTutorialsRoute = AdminAppTutorialsRouteImport.update({
  id: '/tutorials',
  path: '/tutorials',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminResetPasswordTokenRoute = AdminResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => AdminRoute,
} as any);
const AdminVerifyEmailTokenRoute = AdminVerifyEmailTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => AdminVerifyEmailRoute,
} as any);
const AdminAppNotificationsIndexRoute =
  AdminAppNotificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminAppNotificationsRoute,
  } as any);
const AdminAppNotificationsNewRoute =
  AdminAppNotificationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminAppNotificationsRoute,
  } as any);
const AdminAppPipeRatePredictionsIndexRoute =
  AdminAppPipeRatePredictionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminAppPipeRatePredictionsRoute,
  } as any);
const AdminAppPipeRatePredictionsPipeTypeRoute =
  AdminAppPipeRatePredictionsPipeTypeRouteImport.update({
    id: '/$pipeType',
    path: '/$pipeType',
    getParentRoute: () => AdminAppPipeRatePredictionsRoute,
  } as any);
const AdminAppPlatformSettingsIndexRoute =
  AdminAppPlatformSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminAppPlatformSettingsRoute,
  } as any);
const AdminAppPlatformSettingsCalculationRoute =
  AdminAppPlatformSettingsCalculationRouteImport.update({
    id: '/calculation',
    path: '/calculation',
    getParentRoute: () => AdminAppPlatformSettingsRoute,
  } as any);
const AdminAppPlatformSettingsPrivacyPolicyRoute =
  AdminAppPlatformSettingsPrivacyPolicyRouteImport.update({
    id: '/privacy-policy',
    path: '/privacy-policy',
    getParentRoute: () => AdminAppPlatformSettingsRoute,
  } as any);
const AdminAppPlatformSettingsReportPricingRoute =
  AdminAppPlatformSettingsReportPricingRouteImport.update({
    id: '/report-pricing',
    path: '/report-pricing',
    getParentRoute: () => AdminAppPlatformSettingsRoute,
  } as any);
const AdminAppPlatformSettingsReportProTipsRoute =
  AdminAppPlatformSettingsReportProTipsRouteImport.update({
    id: '/report-pro-tips',
    path: '/report-pro-tips',
    getParentRoute: () => AdminAppPlatformSettingsRoute,
  } as any);
const AdminAppPlatformSettingsTermsConditionsRoute =
  AdminAppPlatformSettingsTermsConditionsRouteImport.update({
    id: '/terms-conditions',
    path: '/terms-conditions',
    getParentRoute: () => AdminAppPlatformSettingsRoute,
  } as any);
const AdminAppProjectsIndexRoute = AdminAppProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAppProjectsRoute,
} as any);
const AdminAppProjectsProjectIdRoute =
  AdminAppProjectsProjectIdRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AdminAppProjectsRoute,
  } as any);
const AdminAppUsersIndexRoute = AdminAppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppUsersNewRoute = AdminAppUsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => AdminAppRoute,
} as any);
const AdminAppNotificationsNotificationIdIndexRoute =
  AdminAppNotificationsNotificationIdIndexRouteImport.update({
    id: '/$notificationId/',
    path: '/$notificationId/',
    getParentRoute: () => AdminAppNotificationsRoute,
  } as any);
const AdminAppNotificationsNotificationIdEditRoute =
  AdminAppNotificationsNotificationIdEditRouteImport.update({
    id: '/$notificationId/edit',
    path: '/$notificationId/edit',
    getParentRoute: () => AdminAppNotificationsRoute,
  } as any);
const AdminAppUsersUserIdIndexRoute =
  AdminAppUsersUserIdIndexRouteImport.update({
    id: '/users/$userId/',
    path: '/users/$userId/',
    getParentRoute: () => AdminAppRoute,
  } as any);
const AdminAppUsersUserIdEditRoute = AdminAppUsersUserIdEditRouteImport.update({
  id: '/users/$userId/edit',
  path: '/users/$userId/edit',
  getParentRoute: () => AdminAppRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/admin': typeof AdminRouteWithChildren;
  '/admin/change-password': typeof AdminChangePasswordRoute;
  '/admin/forgot-password': typeof AdminForgotPasswordRoute;
  '/admin/sign-in': typeof AdminSignInRoute;
  '/admin/verify-email': typeof AdminVerifyEmailRouteWithChildren;
  '/admin/advertisement': typeof AdminAppAdvertisementRoute;
  '/admin/banners': typeof AdminAppBannersRoute;
  '/admin/dashboard': typeof AdminAppDashboardRoute;
  '/admin/invoices': typeof AdminAppInvoicesRoute;
  '/admin/notifications': typeof AdminAppNotificationsRouteWithChildren;
  '/admin/pipe-rate-predictions': typeof AdminAppPipeRatePredictionsRouteWithChildren;
  '/admin/platform-settings': typeof AdminAppPlatformSettingsRouteWithChildren;
  '/admin/profile': typeof AdminAppProfileRoute;
  '/admin/projects': typeof AdminAppProjectsRouteWithChildren;
  '/admin/prototype-controls': typeof AdminAppPrototypeControlsRoute;
  '/admin/tutorials': typeof AdminAppTutorialsRoute;
  '/admin/reset-password/$token': typeof AdminResetPasswordTokenRoute;
  '/admin/verify-email/$token': typeof AdminVerifyEmailTokenRoute;
  '/admin/notifications/new': typeof AdminAppNotificationsNewRoute;
  '/admin/pipe-rate-predictions/$pipeType': typeof AdminAppPipeRatePredictionsPipeTypeRoute;
  '/admin/platform-settings/calculation': typeof AdminAppPlatformSettingsCalculationRoute;
  '/admin/platform-settings/privacy-policy': typeof AdminAppPlatformSettingsPrivacyPolicyRoute;
  '/admin/platform-settings/report-pricing': typeof AdminAppPlatformSettingsReportPricingRoute;
  '/admin/platform-settings/report-pro-tips': typeof AdminAppPlatformSettingsReportProTipsRoute;
  '/admin/platform-settings/terms-conditions': typeof AdminAppPlatformSettingsTermsConditionsRoute;
  '/admin/projects/$projectId': typeof AdminAppProjectsProjectIdRoute;
  '/admin/users/new': typeof AdminAppUsersNewRoute;
  '/admin/notifications/': typeof AdminAppNotificationsIndexRoute;
  '/admin/pipe-rate-predictions/': typeof AdminAppPipeRatePredictionsIndexRoute;
  '/admin/platform-settings/': typeof AdminAppPlatformSettingsIndexRoute;
  '/admin/projects/': typeof AdminAppProjectsIndexRoute;
  '/admin/users/': typeof AdminAppUsersIndexRoute;
  '/admin/notifications/$notificationId/edit': typeof AdminAppNotificationsNotificationIdEditRoute;
  '/admin/users/$userId/edit': typeof AdminAppUsersUserIdEditRoute;
  '/admin/notifications/$notificationId/': typeof AdminAppNotificationsNotificationIdIndexRoute;
  '/admin/users/$userId/': typeof AdminAppUsersUserIdIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/admin': typeof AdminRouteWithChildren;
  '/admin/change-password': typeof AdminChangePasswordRoute;
  '/admin/forgot-password': typeof AdminForgotPasswordRoute;
  '/admin/sign-in': typeof AdminSignInRoute;
  '/admin/verify-email': typeof AdminVerifyEmailRouteWithChildren;
  '/admin/advertisement': typeof AdminAppAdvertisementRoute;
  '/admin/banners': typeof AdminAppBannersRoute;
  '/admin/dashboard': typeof AdminAppDashboardRoute;
  '/admin/invoices': typeof AdminAppInvoicesRoute;
  '/admin/profile': typeof AdminAppProfileRoute;
  '/admin/prototype-controls': typeof AdminAppPrototypeControlsRoute;
  '/admin/tutorials': typeof AdminAppTutorialsRoute;
  '/admin/reset-password/$token': typeof AdminResetPasswordTokenRoute;
  '/admin/verify-email/$token': typeof AdminVerifyEmailTokenRoute;
  '/admin/notifications/new': typeof AdminAppNotificationsNewRoute;
  '/admin/pipe-rate-predictions/$pipeType': typeof AdminAppPipeRatePredictionsPipeTypeRoute;
  '/admin/platform-settings/calculation': typeof AdminAppPlatformSettingsCalculationRoute;
  '/admin/platform-settings/privacy-policy': typeof AdminAppPlatformSettingsPrivacyPolicyRoute;
  '/admin/platform-settings/report-pricing': typeof AdminAppPlatformSettingsReportPricingRoute;
  '/admin/platform-settings/report-pro-tips': typeof AdminAppPlatformSettingsReportProTipsRoute;
  '/admin/platform-settings/terms-conditions': typeof AdminAppPlatformSettingsTermsConditionsRoute;
  '/admin/projects/$projectId': typeof AdminAppProjectsProjectIdRoute;
  '/admin/users/new': typeof AdminAppUsersNewRoute;
  '/admin/notifications': typeof AdminAppNotificationsIndexRoute;
  '/admin/pipe-rate-predictions': typeof AdminAppPipeRatePredictionsIndexRoute;
  '/admin/platform-settings': typeof AdminAppPlatformSettingsIndexRoute;
  '/admin/projects': typeof AdminAppProjectsIndexRoute;
  '/admin/users': typeof AdminAppUsersIndexRoute;
  '/admin/notifications/$notificationId/edit': typeof AdminAppNotificationsNotificationIdEditRoute;
  '/admin/users/$userId/edit': typeof AdminAppUsersUserIdEditRoute;
  '/admin/notifications/$notificationId': typeof AdminAppNotificationsNotificationIdIndexRoute;
  '/admin/users/$userId': typeof AdminAppUsersUserIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/admin': typeof AdminRouteWithChildren;
  '/admin/_app': typeof AdminAppRouteWithChildren;
  '/admin/change-password': typeof AdminChangePasswordRoute;
  '/admin/forgot-password': typeof AdminForgotPasswordRoute;
  '/admin/sign-in': typeof AdminSignInRoute;
  '/admin/verify-email': typeof AdminVerifyEmailRouteWithChildren;
  '/admin/_app/advertisement': typeof AdminAppAdvertisementRoute;
  '/admin/_app/banners': typeof AdminAppBannersRoute;
  '/admin/_app/dashboard': typeof AdminAppDashboardRoute;
  '/admin/_app/invoices': typeof AdminAppInvoicesRoute;
  '/admin/_app/notifications': typeof AdminAppNotificationsRouteWithChildren;
  '/admin/_app/pipe-rate-predictions': typeof AdminAppPipeRatePredictionsRouteWithChildren;
  '/admin/_app/platform-settings': typeof AdminAppPlatformSettingsRouteWithChildren;
  '/admin/_app/profile': typeof AdminAppProfileRoute;
  '/admin/_app/projects': typeof AdminAppProjectsRouteWithChildren;
  '/admin/_app/prototype-controls': typeof AdminAppPrototypeControlsRoute;
  '/admin/_app/tutorials': typeof AdminAppTutorialsRoute;
  '/admin/reset-password/$token': typeof AdminResetPasswordTokenRoute;
  '/admin/verify-email/$token': typeof AdminVerifyEmailTokenRoute;
  '/admin/_app/notifications/new': typeof AdminAppNotificationsNewRoute;
  '/admin/_app/pipe-rate-predictions/$pipeType': typeof AdminAppPipeRatePredictionsPipeTypeRoute;
  '/admin/_app/platform-settings/calculation': typeof AdminAppPlatformSettingsCalculationRoute;
  '/admin/_app/platform-settings/privacy-policy': typeof AdminAppPlatformSettingsPrivacyPolicyRoute;
  '/admin/_app/platform-settings/report-pricing': typeof AdminAppPlatformSettingsReportPricingRoute;
  '/admin/_app/platform-settings/report-pro-tips': typeof AdminAppPlatformSettingsReportProTipsRoute;
  '/admin/_app/platform-settings/terms-conditions': typeof AdminAppPlatformSettingsTermsConditionsRoute;
  '/admin/_app/projects/$projectId': typeof AdminAppProjectsProjectIdRoute;
  '/admin/_app/users/new': typeof AdminAppUsersNewRoute;
  '/admin/_app/notifications/': typeof AdminAppNotificationsIndexRoute;
  '/admin/_app/pipe-rate-predictions/': typeof AdminAppPipeRatePredictionsIndexRoute;
  '/admin/_app/platform-settings/': typeof AdminAppPlatformSettingsIndexRoute;
  '/admin/_app/projects/': typeof AdminAppProjectsIndexRoute;
  '/admin/_app/users/': typeof AdminAppUsersIndexRoute;
  '/admin/_app/notifications/$notificationId/edit': typeof AdminAppNotificationsNotificationIdEditRoute;
  '/admin/_app/users/$userId/edit': typeof AdminAppUsersUserIdEditRoute;
  '/admin/_app/notifications/$notificationId/': typeof AdminAppNotificationsNotificationIdIndexRoute;
  '/admin/_app/users/$userId/': typeof AdminAppUsersUserIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/admin'
    | '/admin/change-password'
    | '/admin/forgot-password'
    | '/admin/sign-in'
    | '/admin/verify-email'
    | '/admin/advertisement'
    | '/admin/banners'
    | '/admin/dashboard'
    | '/admin/invoices'
    | '/admin/notifications'
    | '/admin/pipe-rate-predictions'
    | '/admin/platform-settings'
    | '/admin/profile'
    | '/admin/projects'
    | '/admin/prototype-controls'
    | '/admin/tutorials'
    | '/admin/reset-password/$token'
    | '/admin/verify-email/$token'
    | '/admin/notifications/new'
    | '/admin/pipe-rate-predictions/$pipeType'
    | '/admin/platform-settings/calculation'
    | '/admin/platform-settings/privacy-policy'
    | '/admin/platform-settings/report-pricing'
    | '/admin/platform-settings/report-pro-tips'
    | '/admin/platform-settings/terms-conditions'
    | '/admin/projects/$projectId'
    | '/admin/users/new'
    | '/admin/notifications/'
    | '/admin/pipe-rate-predictions/'
    | '/admin/platform-settings/'
    | '/admin/projects/'
    | '/admin/users/'
    | '/admin/notifications/$notificationId/edit'
    | '/admin/users/$userId/edit'
    | '/admin/notifications/$notificationId/'
    | '/admin/users/$userId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/admin'
    | '/admin/change-password'
    | '/admin/forgot-password'
    | '/admin/sign-in'
    | '/admin/verify-email'
    | '/admin/advertisement'
    | '/admin/banners'
    | '/admin/dashboard'
    | '/admin/invoices'
    | '/admin/profile'
    | '/admin/prototype-controls'
    | '/admin/tutorials'
    | '/admin/reset-password/$token'
    | '/admin/verify-email/$token'
    | '/admin/notifications/new'
    | '/admin/pipe-rate-predictions/$pipeType'
    | '/admin/platform-settings/calculation'
    | '/admin/platform-settings/privacy-policy'
    | '/admin/platform-settings/report-pricing'
    | '/admin/platform-settings/report-pro-tips'
    | '/admin/platform-settings/terms-conditions'
    | '/admin/projects/$projectId'
    | '/admin/users/new'
    | '/admin/notifications'
    | '/admin/pipe-rate-predictions'
    | '/admin/platform-settings'
    | '/admin/projects'
    | '/admin/users'
    | '/admin/notifications/$notificationId/edit'
    | '/admin/users/$userId/edit'
    | '/admin/notifications/$notificationId'
    | '/admin/users/$userId';
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/admin/_app'
    | '/admin/change-password'
    | '/admin/forgot-password'
    | '/admin/sign-in'
    | '/admin/verify-email'
    | '/admin/_app/advertisement'
    | '/admin/_app/banners'
    | '/admin/_app/dashboard'
    | '/admin/_app/invoices'
    | '/admin/_app/notifications'
    | '/admin/_app/pipe-rate-predictions'
    | '/admin/_app/platform-settings'
    | '/admin/_app/profile'
    | '/admin/_app/projects'
    | '/admin/_app/prototype-controls'
    | '/admin/_app/tutorials'
    | '/admin/reset-password/$token'
    | '/admin/verify-email/$token'
    | '/admin/_app/notifications/new'
    | '/admin/_app/pipe-rate-predictions/$pipeType'
    | '/admin/_app/platform-settings/calculation'
    | '/admin/_app/platform-settings/privacy-policy'
    | '/admin/_app/platform-settings/report-pricing'
    | '/admin/_app/platform-settings/report-pro-tips'
    | '/admin/_app/platform-settings/terms-conditions'
    | '/admin/_app/projects/$projectId'
    | '/admin/_app/users/new'
    | '/admin/_app/notifications/'
    | '/admin/_app/pipe-rate-predictions/'
    | '/admin/_app/platform-settings/'
    | '/admin/_app/projects/'
    | '/admin/_app/users/'
    | '/admin/_app/notifications/$notificationId/edit'
    | '/admin/_app/users/$userId/edit'
    | '/admin/_app/notifications/$notificationId/'
    | '/admin/_app/users/$userId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AdminRoute: typeof AdminRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin': {
      id: '/admin';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin/_app': {
      id: '/admin/_app';
      path: '';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminAppRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/change-password': {
      id: '/admin/change-password';
      path: '/change-password';
      fullPath: '/admin/change-password';
      preLoaderRoute: typeof AdminChangePasswordRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/forgot-password': {
      id: '/admin/forgot-password';
      path: '/forgot-password';
      fullPath: '/admin/forgot-password';
      preLoaderRoute: typeof AdminForgotPasswordRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/sign-in': {
      id: '/admin/sign-in';
      path: '/sign-in';
      fullPath: '/admin/sign-in';
      preLoaderRoute: typeof AdminSignInRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/verify-email': {
      id: '/admin/verify-email';
      path: '/verify-email';
      fullPath: '/admin/verify-email';
      preLoaderRoute: typeof AdminVerifyEmailRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/_app/advertisement': {
      id: '/admin/_app/advertisement';
      path: '/advertisement';
      fullPath: '/admin/advertisement';
      preLoaderRoute: typeof AdminAppAdvertisementRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/banners': {
      id: '/admin/_app/banners';
      path: '/banners';
      fullPath: '/admin/banners';
      preLoaderRoute: typeof AdminAppBannersRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/dashboard': {
      id: '/admin/_app/dashboard';
      path: '/dashboard';
      fullPath: '/admin/dashboard';
      preLoaderRoute: typeof AdminAppDashboardRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/invoices': {
      id: '/admin/_app/invoices';
      path: '/invoices';
      fullPath: '/admin/invoices';
      preLoaderRoute: typeof AdminAppInvoicesRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/notifications': {
      id: '/admin/_app/notifications';
      path: '/notifications';
      fullPath: '/admin/notifications';
      preLoaderRoute: typeof AdminAppNotificationsRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/pipe-rate-predictions': {
      id: '/admin/_app/pipe-rate-predictions';
      path: '/pipe-rate-predictions';
      fullPath: '/admin/pipe-rate-predictions';
      preLoaderRoute: typeof AdminAppPipeRatePredictionsRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/platform-settings': {
      id: '/admin/_app/platform-settings';
      path: '/platform-settings';
      fullPath: '/admin/platform-settings';
      preLoaderRoute: typeof AdminAppPlatformSettingsRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/profile': {
      id: '/admin/_app/profile';
      path: '/profile';
      fullPath: '/admin/profile';
      preLoaderRoute: typeof AdminAppProfileRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/projects': {
      id: '/admin/_app/projects';
      path: '/projects';
      fullPath: '/admin/projects';
      preLoaderRoute: typeof AdminAppProjectsRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/prototype-controls': {
      id: '/admin/_app/prototype-controls';
      path: '/prototype-controls';
      fullPath: '/admin/prototype-controls';
      preLoaderRoute: typeof AdminAppPrototypeControlsRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/tutorials': {
      id: '/admin/_app/tutorials';
      path: '/tutorials';
      fullPath: '/admin/tutorials';
      preLoaderRoute: typeof AdminAppTutorialsRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/reset-password/$token': {
      id: '/admin/reset-password/$token';
      path: '/reset-password/$token';
      fullPath: '/admin/reset-password/$token';
      preLoaderRoute: typeof AdminResetPasswordTokenRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/admin/verify-email/$token': {
      id: '/admin/verify-email/$token';
      path: '/$token';
      fullPath: '/admin/verify-email/$token';
      preLoaderRoute: typeof AdminVerifyEmailTokenRouteImport;
      parentRoute: typeof AdminVerifyEmailRoute;
    };
    '/admin/_app/notifications/': {
      id: '/admin/_app/notifications/';
      path: '/';
      fullPath: '/admin/notifications/';
      preLoaderRoute: typeof AdminAppNotificationsIndexRouteImport;
      parentRoute: typeof AdminAppNotificationsRoute;
    };
    '/admin/_app/notifications/new': {
      id: '/admin/_app/notifications/new';
      path: '/new';
      fullPath: '/admin/notifications/new';
      preLoaderRoute: typeof AdminAppNotificationsNewRouteImport;
      parentRoute: typeof AdminAppNotificationsRoute;
    };
    '/admin/_app/pipe-rate-predictions/': {
      id: '/admin/_app/pipe-rate-predictions/';
      path: '/';
      fullPath: '/admin/pipe-rate-predictions/';
      preLoaderRoute: typeof AdminAppPipeRatePredictionsIndexRouteImport;
      parentRoute: typeof AdminAppPipeRatePredictionsRoute;
    };
    '/admin/_app/pipe-rate-predictions/$pipeType': {
      id: '/admin/_app/pipe-rate-predictions/$pipeType';
      path: '/$pipeType';
      fullPath: '/admin/pipe-rate-predictions/$pipeType';
      preLoaderRoute: typeof AdminAppPipeRatePredictionsPipeTypeRouteImport;
      parentRoute: typeof AdminAppPipeRatePredictionsRoute;
    };
    '/admin/_app/platform-settings/': {
      id: '/admin/_app/platform-settings/';
      path: '/';
      fullPath: '/admin/platform-settings/';
      preLoaderRoute: typeof AdminAppPlatformSettingsIndexRouteImport;
      parentRoute: typeof AdminAppPlatformSettingsRoute;
    };
    '/admin/_app/platform-settings/calculation': {
      id: '/admin/_app/platform-settings/calculation';
      path: '/calculation';
      fullPath: '/admin/platform-settings/calculation';
      preLoaderRoute: typeof AdminAppPlatformSettingsCalculationRouteImport;
      parentRoute: typeof AdminAppPlatformSettingsRoute;
    };
    '/admin/_app/platform-settings/privacy-policy': {
      id: '/admin/_app/platform-settings/privacy-policy';
      path: '/privacy-policy';
      fullPath: '/admin/platform-settings/privacy-policy';
      preLoaderRoute: typeof AdminAppPlatformSettingsPrivacyPolicyRouteImport;
      parentRoute: typeof AdminAppPlatformSettingsRoute;
    };
    '/admin/_app/platform-settings/report-pricing': {
      id: '/admin/_app/platform-settings/report-pricing';
      path: '/report-pricing';
      fullPath: '/admin/platform-settings/report-pricing';
      preLoaderRoute: typeof AdminAppPlatformSettingsReportPricingRouteImport;
      parentRoute: typeof AdminAppPlatformSettingsRoute;
    };
    '/admin/_app/platform-settings/report-pro-tips': {
      id: '/admin/_app/platform-settings/report-pro-tips';
      path: '/report-pro-tips';
      fullPath: '/admin/platform-settings/report-pro-tips';
      preLoaderRoute: typeof AdminAppPlatformSettingsReportProTipsRouteImport;
      parentRoute: typeof AdminAppPlatformSettingsRoute;
    };
    '/admin/_app/platform-settings/terms-conditions': {
      id: '/admin/_app/platform-settings/terms-conditions';
      path: '/terms-conditions';
      fullPath: '/admin/platform-settings/terms-conditions';
      preLoaderRoute: typeof AdminAppPlatformSettingsTermsConditionsRouteImport;
      parentRoute: typeof AdminAppPlatformSettingsRoute;
    };
    '/admin/_app/projects/': {
      id: '/admin/_app/projects/';
      path: '/';
      fullPath: '/admin/projects/';
      preLoaderRoute: typeof AdminAppProjectsIndexRouteImport;
      parentRoute: typeof AdminAppProjectsRoute;
    };
    '/admin/_app/projects/$projectId': {
      id: '/admin/_app/projects/$projectId';
      path: '/$projectId';
      fullPath: '/admin/projects/$projectId';
      preLoaderRoute: typeof AdminAppProjectsProjectIdRouteImport;
      parentRoute: typeof AdminAppProjectsRoute;
    };
    '/admin/_app/users/': {
      id: '/admin/_app/users/';
      path: '/users';
      fullPath: '/admin/users/';
      preLoaderRoute: typeof AdminAppUsersIndexRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/users/new': {
      id: '/admin/_app/users/new';
      path: '/users/new';
      fullPath: '/admin/users/new';
      preLoaderRoute: typeof AdminAppUsersNewRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/notifications/$notificationId/': {
      id: '/admin/_app/notifications/$notificationId/';
      path: '/$notificationId';
      fullPath: '/admin/notifications/$notificationId/';
      preLoaderRoute: typeof AdminAppNotificationsNotificationIdIndexRouteImport;
      parentRoute: typeof AdminAppNotificationsRoute;
    };
    '/admin/_app/notifications/$notificationId/edit': {
      id: '/admin/_app/notifications/$notificationId/edit';
      path: '/$notificationId/edit';
      fullPath: '/admin/notifications/$notificationId/edit';
      preLoaderRoute: typeof AdminAppNotificationsNotificationIdEditRouteImport;
      parentRoute: typeof AdminAppNotificationsRoute;
    };
    '/admin/_app/users/$userId/': {
      id: '/admin/_app/users/$userId/';
      path: '/users/$userId';
      fullPath: '/admin/users/$userId/';
      preLoaderRoute: typeof AdminAppUsersUserIdIndexRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
    '/admin/_app/users/$userId/edit': {
      id: '/admin/_app/users/$userId/edit';
      path: '/users/$userId/edit';
      fullPath: '/admin/users/$userId/edit';
      preLoaderRoute: typeof AdminAppUsersUserIdEditRouteImport;
      parentRoute: typeof AdminAppRoute;
    };
  }
}

interface AdminAppNotificationsRouteChildren {
  AdminAppNotificationsNewRoute: typeof AdminAppNotificationsNewRoute;
  AdminAppNotificationsIndexRoute: typeof AdminAppNotificationsIndexRoute;
  AdminAppNotificationsNotificationIdEditRoute: typeof AdminAppNotificationsNotificationIdEditRoute;
  AdminAppNotificationsNotificationIdIndexRoute: typeof AdminAppNotificationsNotificationIdIndexRoute;
}

const AdminAppNotificationsRouteChildren: AdminAppNotificationsRouteChildren = {
  AdminAppNotificationsNewRoute: AdminAppNotificationsNewRoute,
  AdminAppNotificationsIndexRoute: AdminAppNotificationsIndexRoute,
  AdminAppNotificationsNotificationIdEditRoute:
    AdminAppNotificationsNotificationIdEditRoute,
  AdminAppNotificationsNotificationIdIndexRoute:
    AdminAppNotificationsNotificationIdIndexRoute,
};

const AdminAppNotificationsRouteWithChildren =
  AdminAppNotificationsRoute._addFileChildren(
    AdminAppNotificationsRouteChildren,
  );

interface AdminAppPipeRatePredictionsRouteChildren {
  AdminAppPipeRatePredictionsPipeTypeRoute: typeof AdminAppPipeRatePredictionsPipeTypeRoute;
  AdminAppPipeRatePredictionsIndexRoute: typeof AdminAppPipeRatePredictionsIndexRoute;
}

const AdminAppPipeRatePredictionsRouteChildren: AdminAppPipeRatePredictionsRouteChildren =
  {
    AdminAppPipeRatePredictionsPipeTypeRoute:
      AdminAppPipeRatePredictionsPipeTypeRoute,
    AdminAppPipeRatePredictionsIndexRoute:
      AdminAppPipeRatePredictionsIndexRoute,
  };

const AdminAppPipeRatePredictionsRouteWithChildren =
  AdminAppPipeRatePredictionsRoute._addFileChildren(
    AdminAppPipeRatePredictionsRouteChildren,
  );

interface AdminAppPlatformSettingsRouteChildren {
  AdminAppPlatformSettingsCalculationRoute: typeof AdminAppPlatformSettingsCalculationRoute;
  AdminAppPlatformSettingsPrivacyPolicyRoute: typeof AdminAppPlatformSettingsPrivacyPolicyRoute;
  AdminAppPlatformSettingsReportPricingRoute: typeof AdminAppPlatformSettingsReportPricingRoute;
  AdminAppPlatformSettingsReportProTipsRoute: typeof AdminAppPlatformSettingsReportProTipsRoute;
  AdminAppPlatformSettingsTermsConditionsRoute: typeof AdminAppPlatformSettingsTermsConditionsRoute;
  AdminAppPlatformSettingsIndexRoute: typeof AdminAppPlatformSettingsIndexRoute;
}

const AdminAppPlatformSettingsRouteChildren: AdminAppPlatformSettingsRouteChildren =
  {
    AdminAppPlatformSettingsCalculationRoute:
      AdminAppPlatformSettingsCalculationRoute,
    AdminAppPlatformSettingsPrivacyPolicyRoute:
      AdminAppPlatformSettingsPrivacyPolicyRoute,
    AdminAppPlatformSettingsReportPricingRoute:
      AdminAppPlatformSettingsReportPricingRoute,
    AdminAppPlatformSettingsReportProTipsRoute:
      AdminAppPlatformSettingsReportProTipsRoute,
    AdminAppPlatformSettingsTermsConditionsRoute:
      AdminAppPlatformSettingsTermsConditionsRoute,
    AdminAppPlatformSettingsIndexRoute: AdminAppPlatformSettingsIndexRoute,
  };

const AdminAppPlatformSettingsRouteWithChildren =
  AdminAppPlatformSettingsRoute._addFileChildren(
    AdminAppPlatformSettingsRouteChildren,
  );

interface AdminAppProjectsRouteChildren {
  AdminAppProjectsProjectIdRoute: typeof AdminAppProjectsProjectIdRoute;
  AdminAppProjectsIndexRoute: typeof AdminAppProjectsIndexRoute;
}

const AdminAppProjectsRouteChildren: AdminAppProjectsRouteChildren = {
  AdminAppProjectsProjectIdRoute: AdminAppProjectsProjectIdRoute,
  AdminAppProjectsIndexRoute: AdminAppProjectsIndexRoute,
};

const AdminAppProjectsRouteWithChildren =
  AdminAppProjectsRoute._addFileChildren(AdminAppProjectsRouteChildren);

interface AdminAppRouteChildren {
  AdminAppAdvertisementRoute: typeof AdminAppAdvertisementRoute;
  AdminAppBannersRoute: typeof AdminAppBannersRoute;
  AdminAppDashboardRoute: typeof AdminAppDashboardRoute;
  AdminAppInvoicesRoute: typeof AdminAppInvoicesRoute;
  AdminAppNotificationsRoute: typeof AdminAppNotificationsRouteWithChildren;
  AdminAppPipeRatePredictionsRoute: typeof AdminAppPipeRatePredictionsRouteWithChildren;
  AdminAppPlatformSettingsRoute: typeof AdminAppPlatformSettingsRouteWithChildren;
  AdminAppProfileRoute: typeof AdminAppProfileRoute;
  AdminAppProjectsRoute: typeof AdminAppProjectsRouteWithChildren;
  AdminAppPrototypeControlsRoute: typeof AdminAppPrototypeControlsRoute;
  AdminAppTutorialsRoute: typeof AdminAppTutorialsRoute;
  AdminAppUsersNewRoute: typeof AdminAppUsersNewRoute;
  AdminAppUsersIndexRoute: typeof AdminAppUsersIndexRoute;
  AdminAppUsersUserIdEditRoute: typeof AdminAppUsersUserIdEditRoute;
  AdminAppUsersUserIdIndexRoute: typeof AdminAppUsersUserIdIndexRoute;
}

const AdminAppRouteChildren: AdminAppRouteChildren = {
  AdminAppAdvertisementRoute: AdminAppAdvertisementRoute,
  AdminAppBannersRoute: AdminAppBannersRoute,
  AdminAppDashboardRoute: AdminAppDashboardRoute,
  AdminAppInvoicesRoute: AdminAppInvoicesRoute,
  AdminAppNotificationsRoute: AdminAppNotificationsRouteWithChildren,
  AdminAppPipeRatePredictionsRoute:
    AdminAppPipeRatePredictionsRouteWithChildren,
  AdminAppPlatformSettingsRoute: AdminAppPlatformSettingsRouteWithChildren,
  AdminAppProfileRoute: AdminAppProfileRoute,
  AdminAppProjectsRoute: AdminAppProjectsRouteWithChildren,
  AdminAppPrototypeControlsRoute: AdminAppPrototypeControlsRoute,
  AdminAppTutorialsRoute: AdminAppTutorialsRoute,
  AdminAppUsersNewRoute: AdminAppUsersNewRoute,
  AdminAppUsersIndexRoute: AdminAppUsersIndexRoute,
  AdminAppUsersUserIdEditRoute: AdminAppUsersUserIdEditRoute,
  AdminAppUsersUserIdIndexRoute: AdminAppUsersUserIdIndexRoute,
};

const AdminAppRouteWithChildren = AdminAppRoute._addFileChildren(
  AdminAppRouteChildren,
);

interface AdminVerifyEmailRouteChildren {
  AdminVerifyEmailTokenRoute: typeof AdminVerifyEmailTokenRoute;
}

const AdminVerifyEmailRouteChildren: AdminVerifyEmailRouteChildren = {
  AdminVerifyEmailTokenRoute: AdminVerifyEmailTokenRoute,
};

const AdminVerifyEmailRouteWithChildren =
  AdminVerifyEmailRoute._addFileChildren(AdminVerifyEmailRouteChildren);

interface AdminRouteChildren {
  AdminAppRoute: typeof AdminAppRouteWithChildren;
  AdminChangePasswordRoute: typeof AdminChangePasswordRoute;
  AdminForgotPasswordRoute: typeof AdminForgotPasswordRoute;
  AdminSignInRoute: typeof AdminSignInRoute;
  AdminVerifyEmailRoute: typeof AdminVerifyEmailRouteWithChildren;
  AdminResetPasswordTokenRoute: typeof AdminResetPasswordTokenRoute;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAppRoute: AdminAppRouteWithChildren,
  AdminChangePasswordRoute: AdminChangePasswordRoute,
  AdminForgotPasswordRoute: AdminForgotPasswordRoute,
  AdminSignInRoute: AdminSignInRoute,
  AdminVerifyEmailRoute: AdminVerifyEmailRouteWithChildren,
  AdminResetPasswordTokenRoute: AdminResetPasswordTokenRoute,
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
